import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { OverviewPage } from './pages/OverviewPage';
import { StockPage } from './pages/StockPage';
import { ActionsPage } from './pages/ActionsPage';
import { HistoryPage } from './pages/HistoryPage';
import { SuppliersPage } from './pages/SuppliersPage';
import { SetupPage } from './pages/SetupPage';
import { PublicOutletPage } from './pages/PublicOutletPage';
import { LoginPage } from './pages/LoginPage';
import { UsersPage } from './pages/UsersPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { useAuth } from './auth/AuthContext';
import { useData } from './data/DataContext';

function Internal({ children }: { children: React.ReactNode }) { const {enabled,loading,session}=useAuth(); const {demoMode,productionLoaded,productionError,productionAccessDenied}=useData(); if(loading)return <div className="public-wrap"><section className="public-card"><p>Loading Flowcount…</p></section></div>; if(enabled&&!session)return <LoginPage/>; if(!demoMode&&productionAccessDenied)return <AccessDeniedPage/>; if(!demoMode&&productionError)return <div className="public-wrap"><section className="public-card"><h1>Flowcount needs a reload</h1><p>{productionError}</p><button className="primary wide" onClick={()=>window.location.reload()}>Reload Flowcount</button></section></div>; if(!demoMode&&!productionLoaded)return <div className="public-wrap"><section className="public-card"><p>Loading Flowcount…</p></section></div>; return <Shell>{children}</Shell>; }
export default function App() {
  return <Routes>
    <Route path="/" element={<Navigate to="/app" replace />} />
    <Route path="/public/:code" element={<PublicOutletPage />} />
    <Route path="/auth/set-password" element={<SetPasswordPage />} />
    <Route path="/auth/callback" element={<AuthCallbackPage />} />
    <Route path="/app" element={<Internal><OverviewPage /></Internal>} />
    <Route path="/app/stock" element={<Internal><StockPage /></Internal>} />
    <Route path="/app/actions" element={<Internal><ActionsPage /></Internal>} />
    <Route path="/app/history" element={<Internal><HistoryPage /></Internal>} />
    <Route path="/app/suppliers" element={<Internal><SuppliersPage /></Internal>} />
    <Route path="/app/setup" element={<Internal><SetupPage /></Internal>} />
    <Route path="/app/setup/users" element={<Internal><UsersPage /></Internal>} />
    <Route path="*" element={<Navigate to="/app" replace />} />
  </Routes>;
}
